import { LngLat } from '@yandex/ymaps3-types';
import { ref } from 'vue';
import { useYMaps } from './useYMaps';

const isLocationGettingError = ref(false);

// ростов
// return [39.6753017, 47.2127458];

export function useLocation() {
  async function getLocation(): Promise<LngLat | null> {
    if (isLocationGettingError.value) {
      return null;
    }

    const { waitForYMaps, ymaps3Lib } = useYMaps();

    await waitForYMaps();

    return new Promise(resolve => {
      if (!ymaps3Lib.value) {
        isLocationGettingError.value = true;
        resolve(null);
        return;
      }

      const { geolocation } = ymaps3Lib.value;

      geolocation
        .getPosition()
        .then(position => {
          resolve(position.coords);
        })
        .catch(() => {
          isLocationGettingError.value = true;

          resolve(null);
        });
    });
  }

  return {
    // isLocationLoading,
    isLocationGettingError,
    getLocation
  };
}
